import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState, AppThunk } from './store'
import { get } from '../utils/rest'
import { NavigationItem } from '../types/types'

export interface NavigationState {
  isLoading: boolean
  navigationItems: NavigationItem[]
  currentPage: string | null
}

const createInitialState = (): NavigationState => {
  return {
    isLoading: false,
    navigationItems: [],
    currentPage: null,
  }
}

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState: createInitialState(),
  reducers: {
    fetchNavigationBegin: (state) => {
      state.isLoading = true
    },
    fetchNavigationSuccess: (state, action: PayloadAction<NavigationItem[]>) => {
      state.navigationItems = action.payload
      state.isLoading = false
    },
    setCurrentPageSuccess: (state, action: PayloadAction<string>) => {
      state.currentPage = action.payload
    },
  },
})

export const { fetchNavigationBegin, fetchNavigationSuccess, setCurrentPageSuccess } = navigationSlice.actions

export const fetchNavigationAsync = (): AppThunk => async (dispatch) => {
  dispatch(fetchNavigationBegin())

  try {
    const res = await get<NavigationItem[]>('/api/navigation/navitems')

    if (res.status === 200) {
      dispatch(fetchNavigationSuccess(res.parsedBody?.data as NavigationItem[]))
    }
  } catch {
    /* eslint-disable */
    console.error('Det gick inte att hämta navigeringen')
    /* eslint-enable */
  }
}

export const setCurrentPage =
  (page: string): AppThunk =>
  async (dispatch) =>
    dispatch(setCurrentPageSuccess(page))

export const selectActivePage = (state: RootState): string | null => state.navigation.currentPage
export const selectNavigationState = (state: RootState): NavigationState => state.navigation

export default navigationSlice.reducer
